import * as BaseApi from "api/Base.api";
import { IUserSchoolStudent } from "../../../interfaces/user.interface";

const BASE_URL = "/school/v2/student/home";

//* 원생 홈 화면 정보 요청
//  희문
//  2025. 08. 08


export interface IStudentHomeInfoParams {
    requestedStudentList: IUserSchoolStudent[];
}
export const getStudentHomeInfo = async (): Promise<IStudentHomeInfoParams> => {
    const url = `${BASE_URL}`;
    return await BaseApi.get(url);
};